/**
 *
 * Asynchronously loads the component for SelectedAttributes
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SelectedAttributes = lazyLoad(
  () => import('./index'),
  module => module.SelectedAttributes,
);
